import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import { useGetInstanceConfigQuery } from '../../graphql/schema';

const Layout = () => {
  const { data } = useGetInstanceConfigQuery();

  useEffect(() => {
    document.title = data?.instanceConfig.name ?? 'tausendsassa.ai';

    const favicon = document.querySelector(
      "link[rel~='icon']",
    ) as HTMLLinkElement;
    if (favicon && data?.instanceConfig.logo) {
      favicon.href = data?.instanceConfig.logo;
    }
  }, [data?.instanceConfig]);

  return (
    <div
      className="flex flex-col h-screen pb-0 bg-[#f8f8f8]"
      style={{
        height: (window.navigator as any).standalone ? '100vh' : '100svh',
      }}
    >
      <Header />
      <Outlet />
    </div>
  );
};

export default Layout;
